import { Store } from '../../types'
import { CustomReportArgument } from './types'

export const customReportDateSelector = (state: Store): string | undefined => {
  return state.context.customReports.date
}

export const customReportArgumentsSelector = (state: Store): CustomReportArgument[] | undefined => {
  return state.context.customReports.arguments
}

export const activeReportIdSelector = (state: Store): number | undefined => {
  return state.context.customReports.activeReportId
}
